/**
 * Manage image path requests using the
 * DatasourceManager's url templating system.
 *
 * @example :
            resourcePath.get('mugshot',{ pid : '12345'})
 *            =>  "https://qasecure.mlb.com/images/gameday/mugshots/mlb/12345.jpg"

 *          resourcePath.get('mugshot')
 *            =>  "https://qasecure.mlb.com/images/gameday/mugshots/mlb/default.jpg"
 *
 * @note : To customize url's for differnt projects (milb?), just override paths with set.
 *
 * @example :
 *          resourcePath.set('mugshot',"https://gd.mlb.com/images/gameday/mugshots/milb/{pid}.jpg")
 *          resourcePath.set({
 *              'mugshot' : ""http://securea.mlb.com/gdcross/images/gameday/mugshots/milb/{pid}.jpg"
 *          })
 **/

define(function(require,exports,module){
    var ResourcePathManager = require( "resource-path-manager/resource-path-manager" );
    var gamedayResourcePath = new ResourcePathManager();

    var gamedayStaticLOCAL= "/sections/gameday/bower_components";
    var gamedayStaticQA   = "https://qa-gameday.mlbstatic.com";
    var gamedayStaticBETA = "https://beta-gameday.mlbstatic.com";
    var gamedayStaticPROD = "https://prod-gameday.mlbstatic.com";
    var responsiveGamedayAssets = "/responsive-gameday-assets/1.3.0";

    gamedayResourcePath.set({
            // Images
        mugshot : "https://img.mlbstatic.com/mlb-photos/image/upload/d_people:generic:headshot:83:current.png,w_124,q_auto:best/v1/people/{pid:default}/headshot/83/current",
        mugshotChyron : "https://img.mlbstatic.com/mlb-photos/image/upload/d_people:generic:headshot:83:current.png,w_124,q_auto:best/v1/people/{pid:default}/headshot/83/current",
        mugshotMlb : "https://img.mlbstatic.com/mlb-photos/image/upload/d_people:generic:headshot:83:current.png,w_62,q_auto:best/v1/people/{pid:default}/headshot/83/current",
        mugshotMilb : "https://img.mlbstatic.com/mlb-photos/image/upload/d_people:generic:headshot:83:current.png,w_124,q_auto:best/v1/people/{pid}/headshot/83/milb/current",
        mugshotPreviewMilb : "https://img.mlbstatic.com/mlb-photos/image/upload/d_people:generic:headshot:83:current.png,w_124,q_auto:best/v1/people/{pid}/headshot/83/milb/current",
        mugshotMilbGeneric : "https://img.mlbstatic.com/mlb-photos/image/upload/d_people:generic:headshot:83:current.png,w_124,q_auto:best/v1/people/{pid}/headshot/83/milb/current",
        mugshotDefault : gamedayStaticPROD + responsiveGamedayAssets + "/images/players/player-default@2x.png",
        mugshotMilbDefault : gamedayStaticPROD + responsiveGamedayAssets + "/images/players/player-default@2x.png",
        playerHeader  : "https://img.mlbstatic.com/mlb-photos/image/upload/d_people:generic:action:pitching:current.png/w_525,q_auto:best/v1/people/{pid}/action/pitching/current",
        playerAltHeader  : "https://img.mlbstatic.com/mlb-photos/image/upload/d_people:generic:action:pitching:current.png/w_525,q_auto:best/v1/people/{pid}/action/pitching/away/current",
        playerHeaderDefault : gamedayStaticPROD + responsiveGamedayAssets + "/images/players/summary_photo_default.svg",
        playerHeaderPreviewDefault : gamedayStaticPROD + responsiveGamedayAssets + "/images/players/summary_photo_default.svg",
        batter : gamedayStaticPROD + responsiveGamedayAssets + "/images/batters/{cut}/{team:GENERIC}-{homeOrAway}-{stand}@2x.png",
        nonRetinaBatter : gamedayStaticPROD + responsiveGamedayAssets + "/images/batters/{cut}/{team:GENERIC}-{homeOrAway}-{stand}.png",
        field : gamedayStaticPROD + responsiveGamedayAssets + "/images/fields/{id:generic}.svg",
        pitchDirtCloud: gamedayStaticPROD + responsiveGamedayAssets + "/images/icons/dirt-cloud.png",
        stadiumTop : {
            env_prod: gamedayStaticPROD + responsiveGamedayAssets + "/images/stadiums/{phase}/{id:default}{density}.jpg",
            env_beta: gamedayStaticBETA + responsiveGamedayAssets + "/images/stadiums/{phase}/{id:default}{density}.jpg",
            env_qa: gamedayStaticQA + responsiveGamedayAssets + "/images/stadiums/{phase}/{id:default}{density}.jpg"
        },
        stadiumBottom : gamedayStaticPROD + responsiveGamedayAssets + "/images/stadiums/infield/{id:default}{density}.jpg",
        teamLogo : "https://www.mlbstatic.com/team-logos/{team_id}.svg",
        teamLogoDark : "https://www.mlbstatic.com/team-logos/team-cap-on-dark/{team_id}.svg",
        teamLogoGeneric : "https://www.mlbstatic.com/team-logos/team-cap-on-light/000.svg",
        teamLogoDarkGeneric : "https://www.mlbstatic.com/team-logos/team-cap-on-dark/000.svg",
        teamLogoLarge : "https://www.mlbstatic.com/team-logos/{team_id}.svg",
        teamLogoLargeGeneric : "https://www.mlbstatic.com/team-logos/team-cap-on-light/000.svg",
        teamLogoCircular : "https://securea.mlb.com/mlb/images/team_logos/circular/{file_code}@2x.png",
            //Other
        ticketLink      : "http://mlb.mlb.com/ticketing/singlegame.jsp?c_id={file_code}#game={game_pk}",
        ticketLinkASG   : "http://mlb.mlb.com/mlb/events/all_star/y{year}/all_star_tickets.jsp",
        ticketLinkMilb  : "http://www.milb.com/tickets/singlegame.jsp?sid={file_code}#game={game_pk}",
        highlightsLink  : "https://www.mlb.com/{esPath}video?game_pk={game_pk}",
        playVideoLink   : "https://www.mlb.com/{esPath}video/{cid}",
        fgowUrl         : "https://www.facebook.com/{pageId}/videos/{videoId}",
        youtubeUrl      : "https://www.mlb.com/live-stream-games/youtube",
        recapLink       : {
            env_prod : "https://www.mlb.com/{esPath}news/{cid}?game_pk={game_pk}",
            env_editorial : "https://beta-gcp.mlb.com/{esPath}news/{cid}?game_pk={game_pk}"
        },
        recapCut4Link       : {
            env_prod : "https://www.mlb.com/{esPath}cut4/{cid}?game_pk={game_pk}",
            env_editorial : "https://beta-gcp.mlb.com/{esPath}cut4/{cid}?game_pk={game_pk}"
        },
        shareVideoLink  : "https://www.mlb.com/video/{cid}",
        wrapImage       : {
            env_qa : "https://qasecure.mlb.com{path}",
            env_editorial : "https://betasecure.mlb.com{path}",
            env_prod : "https://securea.mlb.com{path}"
        },
        wrapFallBackImage : gamedayStaticPROD + responsiveGamedayAssets + "/images/wrap/{event}/{season:generic}.jpg",
        wrapFallBackMatchupImage : gamedayStaticPROD + responsiveGamedayAssets + "/images/wrap/{event}/matchups/{away_id}_{home_id}.png",
        tvArchive : {
           env_dev : "https://www.mlb.com/tv/g{game_pk}",
           env_qa : "https://qa-gcp.mlb.com/tv/g{game_pk}",
           env_beta : "https://beta-gcp.mlb.com/tv/g{game_pk}",
           env_prod : "https://www.mlb.com/tv/g{game_pk}"
        },
        condensedGameLink : "http://m.{es}mlb.com/video/v{cid}",
        externalPlayerCardLink  : {
            env_dev : "https://www.mlb.com/{esPath}player/{pid}",
            env_qa : "https://qa-gcp.mlb.com/{esPath}player/{pid}",
            env_beta : "https://beta-gcp.mlb.com/{esPath}player/{pid}",
            env_prod : "https://www.mlb.com/{esPath}player/{pid}"
        },
        internalPlayerCardLink  : {
            env_dev : "https://www.mlb.com/{esPath}player/{pid}",
            env_qa : "https://qa-gcp.mlb.com/{esPath}player/{pid}",
            env_beta : "https://beta-gcp.mlb.com/{esPath}player/{pid}",
            env_prod : "https://www.mlb.com/{esPath}player/{pid}"
        },
         externalPlayerCardLinkMilb  : {
            env_dev : "https://dev-gcp.milb.com/r/player/{pid}",
            env_qa : "https://qa-gcp.milb.com/r/player/{pid}",
            env_beta : "https://beta-gcp.milb.com/r/player/{pid}",
            env_prod : "https://www.milb.com/r/player/{pid}"
        },
        internalPlayerCardLinkMilb  : {
            env_dev : "https://dev-gcp.milb.com/r/player/{pid}",
            env_qa : "https://qa-gcp.milb.com/r/player/{pid}",
            env_beta : "https://beta-gcp.milb.com/r/player/{pid}",
            env_prod : "https://www.milb.com/r/player/{pid}"
        },
        videoPlayer  : {
            env_dev : "https://qa-gcp.mlb.com/unified-player/embed/{contentId}?mute={mute}&volume={volume:75}&autoPlay={autoplay:false}&useHTML={html}&siteSection={siteSection}&playerContext={playerContext:mlb}",
            env_qa : "https://qa-gcp.mlb.com/unified-player/embed/{contentId}?mute={mute}&volume={volume:75}&autoPlay={autoplay:false}&useHTML={html}&siteSection={siteSection}&playerContext={playerContext:mlb}",
            env_beta : "https://beta-gcp.mlb.com/unified-player/embed/{contentId}?mute={mute}&volume={volume:75}&autoPlay={autoplay:false}&useHTML={html}&siteSection={siteSection}&playerContext={playerContext:mlb}",
            env_prod : "https://www.mlb.com/unified-player/embed/{contentId}?mute={mute}&volume={volume:75}&autoPlay={autoplay:false}&useHTML={html}&siteSection={siteSection}&playerContext={playerContext:mlb}"
        },
        gdAudioUpsell  : {
            env_dev : "https://web-secure.mlb.com/enterworkflow.do?flowId=commerce.cart.noUpfrontRegisPurchase&campaignCode=MLBTV_CMPGN&voucherCode=MLBTV_VOCHR&keepWfParams=true&c_id=mlb&sku=2001107599999919921701000",
            env_qa : "https://qasecure.mlb.com/enterworkflow.do?flowId=commerce.cart.noUpfrontRegisPurchase&campaignCode=MLBTV_CMPGN&voucherCode=MLBTV_VOCHR&keepWfParams=true&c_id=mlb&sku=2001107599999919921701000",
            env_beta : "https://web-secure.mlb.com/enterworkflow.do?flowId=commerce.cart.noUpfrontRegisPurchase&campaignCode=MLBTV_CMPGN&voucherCode=MLBTV_VOCHR&keepWfParams=true&c_id=mlb&sku=2001107599999919921701000",
            env_prod : "https://web-secure.mlb.com/enterworkflow.do?flowId=commerce.cart.noUpfrontRegisPurchase&campaignCode=MLBTV_CMPGN&voucherCode=MLBTV_VOCHR&keepWfParams=true&c_id=mlb&sku=2001107599999919921701000"
        },
        tvSubcriptionLink  : "http://mlb.mlb.com/mlb/subscriptions/index.jsp?product=mlbtv&affiliateId={affiliateId:ATBAT}",
        secureServe : {
            env_dev : "https://securea.mlb.com",
            env_qa : "https://qasecure.mlb.com",
            env_beta : "https://securea.mlb.com",
            env_prod : "https://securea.mlb.com"
        },
        tvOauthLogout : {
            env_dev : "https://securea.mlb.com/enterworkflow.do?flowId=registration.logout&forwardUrl=",
            env_qa : "https://qasecure.mlb.com/enterworkflow.do?flowId=registration.logout&forwardUrl=",
            env_beta : "https://securea.mlb.com/enterworkflow.do?flowId=registration.logout&forwardUrl=",
            env_prod : "https://securea.mlb.com/enterworkflow.do?flowId=registration.logout&forwardUrl="
        },
        tvOauthLogin : {
            env_dev : "https://securea.mlb.com/enterworkflow.do?flowId=registration.connect.wizard&c_id=mlb&template=mobile&forwardUrl=",
            env_qa : "https://qasecure.mlb.com/enterworkflow.do?flowId=registration.connect.wizard&c_id=mlb&template=mobile&forwardUrl=",
            env_beta : "https://securea.mlb.com/enterworkflow.do?flowId=registration.connect.wizard&c_id=mlb&template=mobile&forwardUrl=",
            env_prod : "https://securea.mlb.com/enterworkflow.do?flowId=registration.connect.wizard&c_id=mlb&template=mobile&forwardUrl="
        },
        audioMediaService : {
            env_dev : "https://securea.mlb.com/pubajaxws/bamrest/MediaService2_0/op-findUserVerifiedEvent/v-2.3",
            env_qa : "https://qasecure.mlb.com/pubajaxws/bamrest/MediaService2_0/op-findUserVerifiedEvent/v-2.3",
            env_beta : "https://securea.mlb.com/pubajaxws/bamrest/MediaService2_0/op-findUserVerifiedEvent/v-2.3",
            env_prod : "https://securea.mlb.com/pubajaxws/bamrest/MediaService2_0/op-findUserVerifiedEvent/v-2.3"
        },
        jingle : {
            env_dev : gamedayStaticPROD + responsiveGamedayAssets + "/jingles/gif/{jingle}.gif",
            env_qa :  gamedayStaticQA + responsiveGamedayAssets + "/jingles/gif/{jingle}.gif",
            env_beta : gamedayStaticBETA + responsiveGamedayAssets + "/jingles/gif/{jingle}.gif",
            env_prod : gamedayStaticPROD + responsiveGamedayAssets + "/jingles/gif/{jingle}.gif"
        },
        feedapi : {
            env_dev : "https://statsapi.mlb.com/api/v1/game/{pk}/feed/color?language={lang}",
            env_qa : "https://qa-statsapi.mlb.com/api/v1/game/{pk}/feed/color?language={lang}",
            env_beta : "https://statsapi.mlb.com/api/v1/game/{pk}/feed/color?language={lang}",
            env_prod : "https://statsapi.mlb.com/api/v1/game/{pk}/feed/color?language={lang}"
        },
        mlbtvUrl : {
            env_dev : "https://www.mlb.com/tv/g{game_pk}?clickOrigin=Gameday&media_type=video",
            env_qa : "https://qa-gcp.mlb.com/tv/g{game_pk}?clickOrigin=Gameday&media_type=video",
            env_beta : "https://beta-gcp.mlb.com/tv/g{game_pk}?clickOrigin=Gameday&media_type=video",
            env_prod : "https://www.mlb.com/tv/g{game_pk}?clickOrigin=Gameday&media_type=video"
        },
        mlbtvPostseasonUrl : {
            env_dev : "https://www.mlb.com/tv/PSTV/g{game_pk}?clickOrigin=Gameday&media_type=video",
            env_qa : "https://qa-gcp.mlb.com/tv/PSTV/g{game_pk}?clickOrigin=Gameday&media_type=video",
            env_beta : "https://beta-gcp.mlb.com/tv/PSTV/g{game_pk}?clickOrigin=Gameday&media_type=video",
            env_prod : "https://www.mlb.com/tv/PSTV/g{game_pk}?clickOrigin=Gameday&media_type=video"
        },
        promoImageUrl : {
            env_prod: gamedayStaticPROD + responsiveGamedayAssets + "/images/promotions/{id}.png",
            env_beta: gamedayStaticBETA + responsiveGamedayAssets + "/images/promotions/{id}.png",
            env_qa: gamedayStaticQA + responsiveGamedayAssets + "/images/promotions/{id}.png"
        }
    });
    return gamedayResourcePath;
});
